import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CoreService } from '../../../core/services/core.service';

@Component({
  selector: 'bs-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  thisYear = new Date().getUTCFullYear();
  companyName = 'British Shooting Ltd';
  public social;

  constructor(
    public coreService: CoreService,
  ) {
    this.companyName = environment.companyName;
    this.social = environment.social;
  }

  ngOnInit() {
  }

}
